export default from './BidPage';



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanOptions/components/BidPage/index.js